module.exports = __webpack_public_path__ + "static/media/  (155).79b21e3d.jpg";